import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/question-mark.png'


const _hoisted_1 = {
  key: 1,
  href: "https://mingaku.notion.site/141ef296e7748358b8fb8132f190c9b9",
  target: "_blank"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-6"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")

  return (_openBlock(), _createBlock("div", {
    class: ["px-3 py-3 flex items-center text-sm text-left font-medium text-gray-500 transition-all duration-300", _ctx.wrapClass],
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
  }, [
    _createVNode("p", { class: _ctx.textClass }, _toDisplayString(_ctx.text), 3),
    (_ctx.sortable)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["ml-2", _ctx.iconClass]
        }, [
          _createVNode(_component_m_icon, { type: "chevron-down" })
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.text === '権限')
      ? (_openBlock(), _createBlock("a", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true)
  ], 2))
}